export default __webpack_public_path__ + "files/88dedb6490ea5065910ceeca083957b9.jpg";